import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import CustomButton from 'components/CustomButton';
import { useRouter } from 'next/router';
import { useStyles } from './styles';
import useIsMobile from 'hooks/useIsMobile';
import { Icons } from 'components/Icons';
import { useAuthUser } from 'features/auth/AuthUserContext';
import { UserTypeEnum } from 'enums';
import GoogleSignUpButton from 'components/GoogleSignUpButton';
import { getGoogleRedirectLink } from 'utils';
import useGeoData from 'hooks/useGeoData';

const Props = {
  onOpenTemplate: PropTypes.func.isRequired,
  isBusy: PropTypes.bool,
};

export default function SideCardTemplate({ onOpenTemplate, isBusy }) {
  const router = useRouter();
  const classes = useStyles();
  const { isAuthenticated, user } = useAuthUser();
  const isMobile = useIsMobile();
  const { geoData } = useGeoData();

  function handleButtonClick() {
    if (!isAuthenticated) {
      router.push(`/auth/login-register?from_url=${router.basePath + router.asPath}`);
    } else {
      router.push('/unsupported-device');
    }
  }

  return (
    <Box className={classes.sideCard}>
      <Typography className={classes.title} variant="h2">
        Have a professional infographic and <b>enhance your paper impact with a few clicks</b>
      </Typography>

      {!isMobile ? (
        <>
          {!isAuthenticated ? (
            <>
              <CustomButton variant="buttonSecondaryOpenModal">
                Customize this template for free
              </CustomButton>
              <GoogleSignUpButton href={getGoogleRedirectLink(geoData)} />
            </>
          ) : (
            <CustomButton
              variant="buttonSecondary"
              onClick={onOpenTemplate}
              disabled={isBusy || user.tp_user === UserTypeEnum.JOURNAL}
            >
              Customize this template for free
            </CustomButton>
          )}
        </>
      ) : (
        <CustomButton
          onClick={handleButtonClick}
          variant="buttonSecondary"
          className={classes.btnLoginMobile}
        >
          Customize this template for free
        </CustomButton>
      )}

      <ul>
        <li>
          <Icons.checkCircle className={classes.checkIcon} />
          Made by scientist for scientists
        </li>

        <li>
          <Icons.checkCircle className={classes.checkIcon} />
          100% fully customizable
        </li>

        <li>
          <Icons.checkCircle className={classes.checkIcon} />
          Easy to edit: just drag and drop
        </li>

        <li>
          <Icons.checkCircle className={classes.checkIcon} />
          75.000+ of illustrations available
        </li>

        <li>
          <Icons.checkCircle className={classes.checkIcon} />
          Download, present and share easily
        </li>
      </ul>
    </Box>
  );
}

SideCardTemplate.propTypes = Props;
